export const CHANGE_POPUP_DETAILS_VIEW_STATE =
  '@@PopUpDetailsContent/CHANGE_POPUP_DETAILS_VIEW_STATE';

export const change_popup_details_view_state = value => ({
  type: CHANGE_POPUP_DETAILS_VIEW_STATE,
  payload: value
});
